var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c(
        "cargo-advance-select",
        _vm._b(
          {
            ref: "select",
            attrs: {
              "default-value": _vm.params.isZero ? _vm.value || "" : _vm.value,
              "automatic-dropdown": true,
              "data-option": _vm.params.data
            },
            on: { parentCallBack: _vm.onParentCallBack }
          },
          "cargo-advance-select",
          _vm.selectProps,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }